module.exports = __webpack_public_path__ + "img/wysjfw1.e5f73215.png";